module.exports = __webpack_public_path__ + "img/list.37d73adb.svg";